import React from 'react';
import Router from './router';
import {
  ThemeProvider as ScThemeProvider,
  DefaultTheme,
} from 'styled-components';
import {
  createMuiTheme,
  ThemeProvider as MuiThemeProvider,
} from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import GlobalStyles from './styles/GlobalStyles';
import ContextState from './context/ContextState';

const LandingPageTheme: DefaultTheme = {
  colors: {
    main: '#E3232A',
    secondary: '#424244',
    background: '#ffffff',
    text: {
      main: '#424244',
      secondary: '#F0F0F0',
    },
  },
};

const DashboardTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#E3232A',
    },
    text: {
      primary: '#424244',
    },
  },
  typography: {
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
  },
});

function App() {
  return (
    <ContextState>
      <SnackbarProvider>
        <MuiThemeProvider theme={DashboardTheme}>
          <ScThemeProvider theme={LandingPageTheme}>
            <GlobalStyles />
            <Router />
          </ScThemeProvider>
        </MuiThemeProvider>
      </SnackbarProvider>
    </ContextState>
  );
}

export default App;
